import React, {ElementType, FC, Fragment} from 'react';
import useBreakpointLG from 'hooks/useBreakpointLG';
import AsyncMatchListItem from '../../Async/AsyncMatchListItem';
import {MatchGroup} from '../../../utils/types';
import Ad from '../Ad';

import './styles.scss';

interface MatchListProps {
  label?: string;
  matchGroups: Record<string, MatchGroup>;
  ListItemRender?: ElementType;
}

const MatchList: FC<MatchListProps> = ({
  label,
  matchGroups,
  ListItemRender = AsyncMatchListItem,
}: MatchListProps) => {
  const isBreakpointLG = useBreakpointLG();
  return (
    <>
      {label && <h2 className="MatchList__label">{label}</h2>}
      {Object.entries(matchGroups).map(([competitionId, {title: groupTitle, groupings}], i) => (
        <Fragment key={competitionId}>
          <section className="MatchList__group">
            {groupTitle && <h3 className="MatchList__title">{groupTitle}</h3>}
            {Object.entries(groupings).map(([groupingId, {title: subTitle, matches}]) => (
              <div key={groupingId}>
                {subTitle && <h4 className="MatchList__subtitle">{subTitle}</h4>}
                {matches.map(match => (
                  <ListItemRender className="MatchList__match" match={match} key={match.matchId} />
                ))}
              </div>
            ))}
          </section>
          {
            !label && !isBreakpointLG && i < Object.keys(matchGroups).length - 1 && '' /* <Ad /> */ // only show ads between competitions if no label (no search), not mobile and not at last position
          }
        </Fragment>
      ))}
    </>
  );
};

export default React.memo(MatchList);
